"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _OffRound = _interopRequireDefault(require("@rsuite/icon-font/lib/action/OffRound"));

// Generated by script, don't edit it please.
var OffRound = (0, _createSvgIcon["default"])({
  as: _OffRound["default"],
  ariaLabel: 'off round',
  category: 'action',
  displayName: 'OffRound'
});
var _default = OffRound;
exports["default"] = _default;
module.exports = exports.default;